<section class="searchBarContainer d-flex">
  <select class="form-select select-searchbar" aria-label="Default select example" [(ngModel)]="selected">
    <option value="1" class="text-primary">Coil</option>
    <option value="2" class="text-primary">Order</option>
  </select>
  <input type="text" class="form-control text-search " [(ngModel)]="searchText" (keyup)="onSearchWithempty()"
    (keydown.enter)="onSearch()">
  @if (searchText.length == 0){
  <button class="btn btn-primary btn-searchoverview btn-sm d-flex align-items-center" (click)="onSearch()">
    <i class="material-icons-outlined" style="display: inline-block">search</i>&nbsp;
    <span class="btn-text">
      Overview
    </span>
  </button>
  }
  @else{
  <button class="btn btn-primary btn-search btn-sm d-flex align-items-center" (click)="onSearch()">
    <i class="material-icons-outlined" style="display: inline-block">search</i>&nbsp;
    <span class="btn-text">
      Search
    </span>

  </button>
  }
</section>